module.exports = __webpack_public_path__ + "img/newsImg12.d539ce18.png";